import { render, staticRenderFns } from "./RightSideTabs.vue?vue&type=template&id=7f45437c&scoped=true&"
import script from "./RightSideTabs.vue?vue&type=script&lang=js&"
export * from "./RightSideTabs.vue?vue&type=script&lang=js&"
import style0 from "./RightSideTabs.vue?vue&type=style&index=0&id=7f45437c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f45437c",
  null
  
)

export default component.exports